import { render } from "./categorie.vue?vue&type=template&id=77fabad0&scoped=true"
import script from "./categorie.vue?vue&type=script&lang=js"
export * from "./categorie.vue?vue&type=script&lang=js"

import "./categorie.vue?vue&type=style&index=0&id=77fabad0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77fabad0"]])

export default __exports__